import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-confirmacion',
  templateUrl: './modal-confirmacion.component.html',
  styleUrls: ['./modal-confirmacion.component.css']
})
export class ModalConfirmacionComponent implements OnInit {

  mensaje: string = '';
  
  constructor(private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  onClickClose(event:Event, res:boolean):void{
    this.modal.close(res);
  };

  onClickDismiss(event: Event, res:string):void{
    this.modal.dismiss(res);
  };

}
